import React from 'react'
import ImageDescription from 'components/Slides/ImageDescription'
import PostSvg from '../images/content-php.svg'
import Text from 'components/Text'

export default ImageDescription({
  heading: 'Introducing template tags',
  image: () => <div>
    <PostSvg />
  </div>,

  description: () => (
    <div>
      <p>When we use a loop we get access to each individual post and its data. WordPress has lots of in-built template tags that let us take that data and display it inside our templates.</p>
      <p>Here we have the example of our standard blog-style post and how we can get things like the title and content from it using WordPress template tags.</p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/08-template-tags.js